module.exports = __webpack_public_path__ + "static/media/image1.0ae8399a.jpg";